import { LeadLifecycleStatus } from '@/models/entities/lead';

type LeadLifecycleStatusValue =
  (typeof LeadLifecycleStatus)[keyof typeof LeadLifecycleStatus];

export interface LeadStatusGroup {
  includes(leadStatus: LeadLifecycleStatusValue): boolean;

  url: 'in-progress' | 'archive';
  label: string;
}

const InProgressGroup: LeadStatusGroup = {
  includes(leadStatus) {
    return leadStatus !== LeadLifecycleStatus.Archived;
  },
  url: 'in-progress',
  label: 'In Progress',
} as const;

const ArchiveGroup: LeadStatusGroup = {
  includes(leadStatus) {
    return leadStatus === LeadLifecycleStatus.Archived;
  },
  url: 'archive',
  label: 'Archive',
} as const;

export const LeadStatusGroups = {
  InProgress: InProgressGroup,
  Archive: ArchiveGroup,
  all: [InProgressGroup, ArchiveGroup],
  parse(url: string): LeadStatusGroup {
    const group = LeadStatusGroups.all.find((group) => group.url === url);

    if (!group) {
      throw new Error(`${url} was not a valid status group`);
    }

    return group;
  },
  from(leadStatus: LeadLifecycleStatusValue): LeadStatusGroup {
    const group = LeadStatusGroups.all.find((group) =>
      group.includes(leadStatus),
    );

    if (!group) {
      throw new Error(`${leadStatus} was not a valid LeadStatusGroup`);
    }

    return group;
  },
} as const;
